import { getProviderFromId } from '~/utils/providers'
import { getProviderRouteFromSlug } from '~/utils/route'
import { sentenceCase } from '~/utils/string'

const SLUG_TO_FILTER = {
  broadband_and_digital_tv: 'Broadband + TV',
  broadband_only: 'Broadband',
  cheap_broadband: '£0-£25',
  contract_length_12: '12 months',
  fibre_optic: 'Fibre broadband',
  mobile_broadband: '5G Broadband',
  no_contract: '1 month',
  speed_100_mbps: '100+ Mbps',
  fixed_price_broadband: 'Fixed price broadband'
}

export const getFilterTagTitleFromSlug = (slug) => {
  if (SLUG_TO_FILTER[slug]) return SLUG_TO_FILTER[slug]
  return getProviderNameFromSlug(slug)
}

const SLUG_TO_NO_DEALS_LABEL = {
  broadband_and_digital_tv: 'TV & broadband deals',
  broadband_and_free_line_rental: 'deals with free line rental',
  broadband_with_free_gifts: 'deals with free gifts',
  cheap_broadband: 'cheap broadband deals',
  contract_length_12: '12 month contract deals',
  free_broadband: 'deals with no setup cost',
  no_contract: 'deals with no contract',
  speed_100_mbps: '100 Mbps+ deals',
  fixed_price_broadband: 'fixed price deals'
}

export const getNoDealsLabelFromSlug = (slug) => {
  if (SLUG_TO_NO_DEALS_LABEL[slug]) return SLUG_TO_NO_DEALS_LABEL[slug]
  const providerName = getProviderNameFromSlug(slug)
  if (providerName) return `${providerName} deals`
  return null
}

const getProviderNameFromSlug = (slug) => {
  const providerRoute = getProviderRouteFromSlug(slug)
  if (providerRoute) {
    const formattedSlug = sentenceCase(slug.replaceAll('_', ' '))
    return getProviderFromId(providerRoute.providerId)?.name ?? formattedSlug
  }

  return null
}
